import { getHeaders, getBaseURL } from './MediaRepository';
import createHTTP from './apiService';

var getHTTPInstance = function getHTTPInstance() {
  return createHTTP(getBaseURL(), getHeaders());
};

export var sendEmail = function sendEmail(payload) {
  return getHTTPInstance().post('/api/consumer_emailservice/u/consumer_ems/sendEmail', payload);
};
export var sendEmailForRO = function sendEmailForRO(payload) {
  return getHTTPInstance().post('/api/ro/u/sendEmail', payload);
};
export var validateEmail = function validateEmail(emailId) {
  return getHTTPInstance().get("/api/service-module/u/v1/validate/recipient/email?emailId=".concat(emailId));
};
export var validatePhoneEmailAndAddress = function validatePhoneEmailAndAddress(payload) {
  return getHTTPInstance().post('/api/platform-commons/u/eavs2/validation', payload);
};